import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Lock, FileCheck2, ArrowRight } from "lucide-react";
import { SupportFooter } from "@/components/SupportContact";

const HERO = "https://customer-assets-0z36b82j.emergentagent.net/job_becas-socios/artifacts/i6c85iq7_B7D4189A-BE85-4561-B336-DBE4B066AA89.PNG";

export default function Home() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <header className="bg-white border-b border-border">
        <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img src="/eim-logo.png" alt="EIM" className="w-9 h-9 object-contain" />
            <span className="font-heading font-extrabold text-lg text-primary">EIM Becas</span>
          </div>
          <div className="flex items-center gap-1">
            <Button variant="ghost" onClick={() => navigate("/manual-usuario")} data-testid="nav-manual-btn">Manual</Button>
            <Button variant="ghost" onClick={() => navigate("/ingresar")} data-testid="nav-login-btn">Ingresar</Button>
          </div>
        </div>
      </header>

      <section className="max-w-6xl mx-auto px-5 py-12 lg:py-20 grid lg:grid-cols-2 gap-12 items-center fade-in">
        <div>
          <div className="inline-flex items-center gap-2 bg-secondary text-primary px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <Lock className="w-4 h-4" /> Sitio privado y confidencial
          </div>
          <img src="/eim-logo.png" alt="Estadio Israelita Maccabi" className="w-20 h-20 object-contain mb-6" />
          <h1 className="text-4xl sm:text-5xl font-black text-primary tracking-tight mb-6">
            EIM Becas
          </h1>
          <p className="text-lg text-foreground leading-relaxed mb-4">
            Este es un sitio privado y confidencial del <strong>Estadio Israelita Maccabi</strong>.
          </p>
          <p className="text-base text-muted-foreground leading-relaxed mb-8 max-w-xl">
            Aquí podrás completar de manera segura los antecedentes necesarios para solicitar una reducción
            de tu cuota anual de socio, de acuerdo con las necesidades de tu grupo familiar. Toda la información
            entregada será tratada de manera estrictamente confidencial y utilizada exclusivamente para evaluar tu solicitud.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              className="btn-lift h-14 text-lg px-8 rounded-xl"
              onClick={() => navigate("/registro")}
              data-testid="btn-start-application"
            >
              Iniciar solicitud <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            <Button
              variant="outline"
              className="btn-lift h-14 text-lg px-8 rounded-xl border-2 border-primary text-primary bg-white"
              onClick={() => navigate("/ingresar")}
              data-testid="btn-have-application"
            >
              Ya tengo una solicitud / Ingresar
            </Button>
          </div>
        </div>
        <div className="relative">
          <div className="rounded-2xl overflow-hidden border border-border shadow-sm">
            <img src={HERO} alt="Familia socia del Estadio Israelita Maccabi" className="w-full h-[420px] object-cover object-[50%_42%]" />
            <div className="absolute inset-0 bg-primary/10 rounded-2xl" />
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-5 pb-20 grid sm:grid-cols-3 gap-6">
        {[
          { icon: Lock, t: "Confidencial", d: "Tus datos se almacenan cifrados y separados. Nunca se comparten fuera de la evaluación." },
          { icon: FileCheck2, t: "Simple y guiado", d: "Un asistente paso a paso guarda tu avance automáticamente. Puedes continuar cuando quieras." },
          { icon: ShieldCheck, t: "Evaluación justa", d: "Tu solicitud es revisada por el comité de becas con criterios claros y trazables." },
        ].map((f, i) => (
          <div key={i} className="bg-white rounded-2xl border border-border p-8">
            <f.icon className="w-8 h-8 text-accent mb-4" />
            <h3 className="text-xl font-semibold mb-2">{f.t}</h3>
            <p className="text-muted-foreground text-base">{f.d}</p>
          </div>
        ))}
      </section>
      <SupportFooter />
    </div>
  );
}
